import { useContext, useState } from 'react';
import {
  Box,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import {
  ArrowForward,
  History,
  Inventory2Outlined,
  Search,
} from '@mui/icons-material';
import { useModal } from 'components/Modals';
import { useForm } from 'react-hook-form';
import { GarantiasContext } from 'contexts/GarantiasContext';
import Button from 'components/Button';
import Input from 'components/Input';
import Card from 'components/Card';

const ConsultaPecaModal = () => {
  const defaultValues = { referencia: '' };

  const { closeModal } = useModal();
  const [peca, setPeca] = useState(null);
  const [error, setError] = useState(false);

  const { control, handleSubmit } = useForm({ defaultValues });
  const { getConsultaPeca, getLoading } = useContext(GarantiasContext);

  const onSearch = (params) => {
    setError(false);
    setPeca(null);

    getConsultaPeca({
      params,
      cb: (res) => {
        if (res) {
          setPeca(res);
          setError(false);
        } else {
          setPeca(null);
          setError(true);
        }
      },
    });
  };

  const referencias = peca?.caminho
    ? peca.caminho.split('->').filter(Boolean)
    : [];

  return (
    <>
      <DialogTitle>Consulta de Peça</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} />
          <Grid item xs={12}>
            <Input name="referencia" control={control} label="Referência" />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="outlined"
              loading={getLoading}
              startIcon={<Search />}
              onClick={handleSubmit(onSearch)}
            >
              Pesquisar
            </Button>
          </Grid>
          {!peca && (
            <Grid item xs={12} textAlign="center">
              <Typography
                color={error ? 'error' : 'text.secondary'}
                variant="caption"
              >
                {error
                  ? 'Nenhuma outra referência encontrada'
                  : 'Pesquise uma referência'}
              </Typography>
            </Grid>
          )}
          {peca && (
            <Grid item xs={12}>
              <Card>
                <Box gap={2} display="flex" flexDirection="column">
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Inventory2Outlined color="primary" />
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Referência atual
                      </Typography>
                      <Typography variant="h6" fontWeight="bold">
                        {peca?.referencia || '-'}
                      </Typography>
                    </Box>
                  </Stack>
                  <Divider />
                  <Box gap={1} display="flex" flexDirection="column">
                    <Typography variant="caption" color="text.secondary">
                      Descrição
                    </Typography>
                    <Typography variant="body1">
                      {peca?.descricao || 'Sem descrição'}
                    </Typography>
                  </Box>
                  {referencias.length > 0 && (
                    <>
                      <Divider />
                      <Box>
                        <Stack
                          spacing={2}
                          direction="row"
                          alignItems="center"
                          mb={1}
                        >
                          <History fontSize="small" color="action" />
                          <Typography variant="subtitle2" fontWeight="bold">
                            Histórico de referências
                          </Typography>
                        </Stack>
                        <Stack
                          useFlexGap
                          spacing={1}
                          flexWrap="wrap"
                          direction="row"
                          alignItems="center"
                        >
                          {referencias.map((referencia, index) => {
                            const isAtual = index === referencias.length - 1;

                            return (
                              <Stack
                                spacing={1}
                                direction="row"
                                alignItems="center"
                                key={`${referencia}-${index}`}
                              >
                                <Chip
                                  size="small"
                                  label={referencia}
                                  color={isAtual ? 'primary' : 'default'}
                                  variant={isAtual ? 'filled' : 'outlined'}
                                />
                                {!isAtual && (
                                  <ArrowForward
                                    fontSize="small"
                                    color="action"
                                  />
                                )}
                              </Stack>
                            );
                          })}
                        </Stack>
                      </Box>
                    </>
                  )}
                </Box>
              </Card>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>Voltar</Button>
      </DialogActions>
    </>
  );
};

export default ConsultaPecaModal;
